module.exports = __webpack_public_path__ + "static/img/fz_fz_tz.588ff88.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_fz_tz.png
// module id = cNBR
// module chunks = 0